import api from '../../api/client';
import React, { useState, useEffect } from 'react';
import { 
    Card, Row, Col, Statistic, Table, Spin, Tag, Select, 
    Space, Button, Badge, Progress, Tooltip, Typography
} from 'antd';
import { 
    ShoppingOutlined, DollarOutlined, TeamOutlined, 
    RiseOutlined, FallOutlined, ReloadOutlined, 
    EyeOutlined, CheckCircleOutlined, CloseCircleOutlined,
    HeartOutlined,
    MoneyCollectOutlined
} from '@ant-design/icons';
import axios from 'axios';
import config from '../../config';
import { formatKES } from '../../utils/currency';

const { Title, Text } = Typography;
const { Option } = Select;

function AnimalAssetsDashboard({ farms }) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({ summary: {}, grouped: [], details: [] });
    const [assetTypes, setAssetTypes] = useState([]);
    const [filters, setFilters] = useState({ farm: 'all', status: 'all', type_slug: 'all' });
    const environment = window.location.hostname === "localhost" ? "development" : "production";
      const apiUrl = config[environment].apiUrl;

    useEffect(() => {
        fetchData();
        fetchAssetTypes();
    }, [filters]);
    
    const fetchData = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams(filters);
            const res = await api.get(`/dashboard/animal-assets-summary?${params}`);
            setData(res.data);
        } catch (err) {
            console.error('Failed to fetch animal assets', err);
        } finally {
            setLoading(false);
        }
    };
    
    const fetchAssetTypes = async () => {
        try {
            const res = await api.get(`/dashboard/asset-types`);
            setAssetTypes(res.data);
        } catch (err) {
            console.error('Failed to fetch asset types', err);
        }
    };
    
    // Color mapping for asset types
    const typeColors = {
        goat: 'green',
        sheep: 'blue',
        pig: 'orange',
        poultry: 'gold',
        weaner: 'purple',
        cattle: 'cyan',
        land: 'brown',
        equipment: 'volcano',
        vehicle: 'geekblue',
        building: 'lime',
        tray: 'pink',
        default: 'pink'
    };

    // Get active/alive count for each type
    const getActiveCount = (typeSlug) => {
        const activeData = data.grouped?.filter(
            item => item.type_slug === typeSlug && (item.status === 'alive' || item.status === 'active')
        ) || [];
        return activeData.reduce((sum, item) => sum + (item.total_count || 0), 0);
    };
    
    // Get total quantity for each type
    const getTotalQuantity = (typeSlug) => {
        const typeData = data.grouped?.filter(item => item.type_slug === typeSlug) || [];
        return typeData.reduce((sum, item) => sum + (item.total_quantity || 0), 0);
    };
    
    // Get total value for each type
    const getTotalValue = (typeSlug) => {
        const typeData = data.grouped?.filter(item => item.type_slug === typeSlug) || [];
        return typeData.reduce((sum, item) => sum + (item.current_value || 0), 0);
    };
    
    const assetCards = assetTypes.map(type => {
        const activeCount = getActiveCount(type.slug);
        const totalQuantity = getTotalQuantity(type.slug);
        const totalValue = getTotalValue(type.slug);
        const percentage = type.asset_count > 0 ? (activeCount / type.asset_count) * 100 : 0;
        
        return (
            <Col xs={24} sm={12} md={8} lg={6} xl={4} key={type.id}>
                <Card 
                    size="small"
                    style={{ 
                        marginBottom: 16, 
                        // borderLeft: `4px solid ${typeColors[type.slug] || '#1890ff'}` 
                    }}
                    bodyStyle={{ padding: '12px' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Badge color={typeColors[type.slug] || 'default'} />
                            <Title level={5} style={{ margin: 0, marginLeft: 8 }}>
                                {type.name}
                            </Title>
                        </div>
                        <Tooltip title="Active/Alive">
                            <HeartOutlined style={{ color: '#52c41a', fontSize: 14 }} />
                        </Tooltip>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>Active/Alive:</Text>
                        <Text strong style={{ color: '#52c41a' }}>{activeCount}</Text>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>Total Quantity:</Text>
                        <Text strong>{totalQuantity}</Text>
                    </div>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>Total Value:</Text>
                        <Text strong style={{ color: '#3f8600' }}>
                            {formatKES(totalValue)}
                        </Text>
                    </div>
                    
                    <Progress 
                        percent={percentage}
                        size="small" 
                        showInfo={true}
                        format={() => `${activeCount}/${type.asset_count || 0}`}
                        strokeColor={typeColors[type.slug] || '#52c41a'}
                    />
                </Card>
            </Col>
        );
    });
    
    const assetCardss = assetTypes.map(type => {
        const stats = data.summary?.byType?.[type.slug] || { count: 0, quantity: 0, value: 0 };
        console.log("stats", stats)
        return (
            <Col xs={24} sm={12} md={8} lg={6} xl={4} key={type.id}>
                <Card 
                    // size="small"
                    style={{ marginBottom: 16 }}
                    bodyStyle={{ padding: '12px' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                        <Badge color={typeColors[type.slug] || 'default'} />
                        <Title level={5} style={{ margin: 0, marginLeft: 8 }}>
                            {type.name}
                        </Title>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>Count:</Text>
                        <Text strong>{stats.count}</Text>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>Quantity:</Text>
                        <Text strong>{stats.quantity}</Text>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>Value:</Text>
                        <Text strong >
                            {formatKES(stats.value || 0)}
                        </Text>
                    </div>
                    <Progress 
                        percent={Math.min((stats.count / (type.asset_count || 1)) * 100, 100)} 
                        size="small" 
                        showInfo={false}
                        strokeColor={typeColors[type.slug]}
                    />
                </Card>
            </Col>
        );
    });
    
    const summaryColumns = [
        { 
            title: 'Type', 
            dataIndex: 'type_slug', 
            key: 'type_slug',
            render: (v) => (
                <Text>{v}</Text>
            )
        },
        { 
            title: 'Status', 
            dataIndex: 'status', 
            key: 'status',
            render: (v) => (
                <Tag color={
                    v === 'alive' ? 'green' : 
                    v === 'sold' ? 'blue' : 
                    v === 'mortality' ? 'red' : 'orange'
                }>{v}</Tag>
            )
        },
        { 
            title: 'Count', 
            dataIndex: 'total_count', 
            key: 'total_count',
            render: (v) => <strong>{v}</strong>
        },
        { 
            title: 'Quantity', 
            dataIndex: 'total_quantity', 
            key: 'total_quantity' 
        },
        { 
            title: 'Males', 
            dataIndex: 'male_count', 
            key: 'male_count' 
        },
        { 
            title: 'Females', 
            dataIndex: 'female_count', 
            key: 'female_count' 
        },
        { 
            title: 'Value ($)', 
            dataIndex: 'current_value', 
            key: 'current_value',
            render: (v) => `${formatKES(v || '0.00')}`
        }
    ];
    
    const detailsColumns = [
        { 
            title: 'ID/Tag', 
            dataIndex: 'tagNumber', 
            key: 'tagNumber',
            render: (v, r) => v || r.batchId || r.id
        },
        { 
            title: 'Type', 
            dataIndex: 'type_slug', 
            key: 'type_slug',
            render: (v) => <Tag color={typeColors[v]}>{v}</Tag>
        },
        { 
            title: 'Name/Breed', 
            dataIndex: 'animalName', 
            key: 'animalName',
            render: (v, r) => v || r.breed || '-'
        },
        { 
            title: 'Gender', 
            dataIndex: 'gender', 
            key: 'gender',
            render: (v) => v === 'male' ? '♂' : v === 'female' ? '♀' : '-'
        },
        { 
            title: 'Qty', 
            dataIndex: 'quantity', 
            key: 'quantity',
            align: 'center'
        },
        { 
            title: 'Value', 
            dataIndex: 'currentValue', 
            key: 'currentValue',
            render: (v) => `${formatKES(v) || '0.00'}`
        },
        { 
            title: 'Status', 
            dataIndex: 'status', 
            key: 'status',
            render: (v) => (
                <Tag size="small" color={
                    v === 'alive' ? 'green' : 
                    v === 'sold' ? 'blue' : 'orange'
                }>{v}</Tag>
            )
        },
        { 
            title: 'Farm', 
            dataIndex: 'farm', 
            key: 'farm' 
        }
    ];
    
    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
                <Spin size="large" tip="Loading assets..." />
            </div>
        );
    }
    
    return (
        <div>
            {/* Filter Bar */}
            <Card style={{ marginBottom: 16 }}>
                <Space size="middle" wrap>
                    <Select 
                        value={filters.farm} 
                        onChange={(v) => setFilters({...filters, farm: v})}
                        style={{ width: 120 }}
                        // size="small"
                    >
                      
                        <Option value="all">All Farms</Option>

                        {farms.map((farm) => (
                            <Option
                                key={farm.id}
                                value={farm.name}
                            >
                                {farm.name}
                            </Option>
                        ))}
                    </Select>
                    <Select 
                        value={filters.status} 
                        onChange={(v) => setFilters({...filters, status: v})}
                        style={{ width: 120 }}
                        // size="small"
                    >
                        <Option value="all">All Status</Option>
                        <Option value="alive">Alive</Option>
                        <Option value="sold">Sold</Option>
                        <Option value="mortality">Mortality</Option>
                    </Select>
                    <Select 
                        value={filters.type_slug} 
                        onChange={(v) => setFilters({...filters, type_slug: v})}
                        style={{ width: 120 }}
                        // size="small"
                        allowClear
                    >
                        <Option value="all">All Types</Option>
                        {assetTypes.map(t => (
                            <Option key={t.slug} value={t.slug}>{t.name}</Option>
                        ))}
                    </Select>
                    <Button 
                        icon={<ReloadOutlined />} 
                        onClick={fetchData}
                        // size="small"
                    >
                        Refresh
                    </Button>
                </Space>
            </Card>
            
            {/* Summary Stats Cards */}
            <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
                <Col xs={12} sm={8} md={6}>
                    <Card 
                    // size="small"
                    >
                        <Statistic 
                            title="Total Animals" 
                            value={data.summary.totalAnimals || 0} 
                            prefix={<TeamOutlined />}
                            valueStyle={{ fontSize: 20 }}
                        />
                    </Card>
                </Col>
                <Col xs={12} sm={8} md={6}>
                    <Card 
                    // size="small"
                    >
                        <Statistic 
                            title="Total Value" 
                            value={data.summary.totalValue || 0} 
                            precision={2}
                            prefix={<MoneyCollectOutlined/>}
                            valueStyle={{ fontSize: 20, color: '#3f8600' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={8} md={12}>
                    <Card 
                    // size="small"
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                            {Object.entries(data.summary.byStatus || {}).map(([status, count]) => (
                                <div key={status}>
                                    <Text type="secondary" style={{ fontSize: 12 }}>{status}:</Text>
                                    <br />
                                    <strong>{count}</strong>
                                </div>
                            ))}
                        </div>
                    </Card>
                </Col>
            </Row>
            
            {/* Asset Type Cards (Small Cards for each type) */}
            <Title level={5} style={{ marginBottom: 8 }}>Assets by Type</Title>
            <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
                {assetCards}
            </Row>
            
            {/* Summary Table by Type and Status */}
            <Card 
                size="small" 
                title="Summary by Type & Status" 
                style={{ marginBottom: 16 }}
            >
                <Table
                    dataSource={data.grouped}
                    columns={summaryColumns}
                    rowKey={(r) => `${r.type_slug}-${r.status}`}
                    pagination={false}
                    size="small"
                    scroll={{ x: 600 }}
                />
            </Card>
            
            {/* Detailed Assets Table */}
            <Card size="small" title="Detailed Assets List">
                <Table
                    dataSource={data.details}
                    columns={detailsColumns}
                    rowKey="id"
                    pagination={{ pageSize: 10, size: 'small' }}
                    size="small"
                    scroll={{ x: 800 }}
                />
            </Card>
        </div>
    );
}

export default AnimalAssetsDashboard;